/**
 * Formats amount in USD format with commas
 * @param {number} amount - cost to be formatted
 * @returns {string}
 */
export const amountSeparator = (amount: number): string => {
  if (Number.isNaN(amount - 0)) {
    return amount.toString();
  }
  const result = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  const [price, cents] = result.split('.');
  if (cents === '00') {
    return price;
  }
  // don't return decimal point when decimal is 0
  return result;
};

/**
 * Formats high, round numbers (thousands or millions) to use commas
 * and replace trailing zeros with "k" or "m" (optionally)
 * @param {?number} value
 * @param {boolean} fullNotation - optionally avoid shortening big numbers to k-notation
 * @returns {string}
 */
export const formatThousand = (value?: number, notation: 'standard' | 'compact' = 'compact'): string => {
  if (!Number.isFinite(value)) {
    return '';
  }

  const formatted = value?.toLocaleString(
    'en',
    {
      notation,
      ...(notation === 'compact' && { maximumSignificantDigits: 3 }),
    },
  );
  return formatted || '';
};
